import React from 'react'
import { Redirect } from 'react-router-dom'

export type RequireAuthOptions = {
  notAuth?: boolean,
  redirectTo: string
}

export const requireAuth = <P extends object>(Component: React.ComponentType<P>, isAuth: boolean, options: RequireAuthOptions): React.FC<P> => (props) => {
  const { notAuth, redirectTo } = options
  if ((notAuth && isAuth) || (!notAuth && !isAuth)) {
    return <Redirect to={redirectTo} />
  }
  return <Component {...props} />
}
